import { useRef, useState, useEffect } from 'react';
import { isUndefined } from '../utils/is.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
function useMergeValue(defaultStateValue, props) {
  const {
    defaultValue,
    value
  } = props || {};
  const firstRenderRef = useRef(true);
  const [stateValue, setStateValue] = useState(() => {
    if (!isUndefined(value)) {
      return value;
    }
    if (!isUndefined(defaultValue)) {
      return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    }
    return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
  });
  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    if (value !== undefined) {
      setStateValue(value);
    }
  }, [value]);
  const mergedValue = value !== undefined ? value : stateValue;
  return [mergedValue, setStateValue, stateValue];
}

export { useMergeValue };
